// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  width: 300px;
  background-color: #2c3e50;
  color: #ecf0f1;
  padding: 20px 0px;
  display: flex;
  flex-direction: column;
}

.sidebar .sidebar-header {
  font-size: 1.2em;
  text-align: center;
  padding: 10px;
  cursor: default;
}

.sidebar-header img {
  width: 40px;
}

.sidebar .menu {
  flex-grow: 1;
  padding: 15px 0;
}

.menu a {
  text-decoration: none;
  color: #ecf0f1;
  padding: 15px 25px;
  border-radius: 4px;
  display: block;
  margin-bottom: 10px;
}

.menu a:hover {
  background-color: rgba(255, 255, 255, 0.075);
  border-left: 3px solid #3b7ddd;
}

.menu .nav-links {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
}

.nav-links i {
  font-size: 1.1rem;
}

#logoutAnchor:hover {
  color: #ff0000;
}

.copyright-container {
  margin-top: auto;
  text-align: center;
  font-size: 0.7em;
  color: #b0b0b0;
}
`, "",{"version":3,"sources":["webpack://./src/styles/sidebar.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,4CAA4C;EAC5C,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":[".sidebar {\r\n  width: 300px;\r\n  background-color: #2c3e50;\r\n  color: #ecf0f1;\r\n  padding: 20px 0px;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.sidebar .sidebar-header {\r\n  font-size: 1.2em;\r\n  text-align: center;\r\n  padding: 10px;\r\n  cursor: default;\r\n}\r\n\r\n.sidebar-header img {\r\n  width: 40px;\r\n}\r\n\r\n.sidebar .menu {\r\n  flex-grow: 1;\r\n  padding: 15px 0;\r\n}\r\n\r\n.menu a {\r\n  text-decoration: none;\r\n  color: #ecf0f1;\r\n  padding: 15px 25px;\r\n  border-radius: 4px;\r\n  display: block;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.menu a:hover {\r\n  background-color: rgba(255, 255, 255, 0.075);\r\n  border-left: 3px solid #3b7ddd;\r\n}\r\n\r\n.menu .nav-links {\r\n  display: flex;\r\n  flex-direction: row;\r\n  gap: 10px;\r\n  align-items: center;\r\n}\r\n\r\n.nav-links i {\r\n  font-size: 1.1rem;\r\n}\r\n\r\n#logoutAnchor:hover {\r\n  color: #ff0000;\r\n}\r\n\r\n.copyright-container {\r\n  margin-top: auto;\r\n  text-align: center;\r\n  font-size: 0.7em;\r\n  color: #b0b0b0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
